import type { MFAAction } from '@dynamic-labs/sdk-api-core';

import type { DynamicClient } from '../../../client/types/DynamicClient';
import { consumeMfaToken } from '../consumeMfaToken';
import { isMfaRequiredForAction } from '../isMfaRequiredForAction';

type ConsumeMfaTokenIfRequiredForActionParams = {
  mfaAction: MFAAction;
};

export const consumeMfaTokenIfRequiredForAction = async (
  { mfaAction }: ConsumeMfaTokenIfRequiredForActionParams,
  client: DynamicClient
): Promise<string | undefined> => {
  const isRequiredForAction = await isMfaRequiredForAction(
    { mfaAction },
    client
  );

  if (!isRequiredForAction) {
    return;
  }

  return consumeMfaToken(client);
};
